export default __webpack_public_path__ + "static/media/Copy of Limit Employee Access.6a6ec129.jpg";